import React, { useState, useEffect } from 'react';
import api from '../api';

function Stats() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
    const interval = setInterval(loadStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadStats = async () => {
    try {
      const [statsData, recentData] = await Promise.all([
        api.getStats(),
        api.getRecentRequests(20),
      ]);
      setStats(statsData);
      setRecent(recentData.requests);
    } catch (err) {
      console.error('Failed to load stats:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <div className="stats-page">
      <div className="page-header">
        <h1>Statistics</h1>
        <button onClick={loadStats} className="btn btn-outline">Refresh</button>
      </div>

      {stats && (
        <>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-value">{stats.overview.totalRequests.toLocaleString()}</div>
              <div className="stat-label">Total Requests</div>
            </div>
            <div className="stat-card stat-success">
              <div className="stat-value">{stats.overview.successfulRequests.toLocaleString()}</div>
              <div className="stat-label">Successful</div>
            </div>
            <div className="stat-card stat-error">
              <div className="stat-value">{stats.overview.failedRequests.toLocaleString()}</div>
              <div className="stat-label">Failed</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.overview.successRate}%</div>
              <div className="stat-label">Success Rate</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.overview.totalTokens.toLocaleString()}</div>
              <div className="stat-label">Total Tokens</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.overview.avgResponseTimeMs}ms</div>
              <div className="stat-label">Avg Response</div>
            </div>
          </div>

          {/* Requests by Model */}
          {stats.byModel.length > 0 && (
            <div className="card">
              <h2>Requests by Model</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Total</th>
                    <th>Success</th>
                    <th>Failed</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.byModel.map(row => (
                    <tr key={row.model}>
                      <td>{row.model}</td>
                      <td>{row.count}</td>
                      <td>{row.success}</td>
                      <td>{row.failed}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* Recent Requests */}
      <div className="card">
        <h2>Recent Requests</h2>
        {recent.length === 0 ? (
          <div className="empty-state"><p>No requests yet.</p></div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Model</th>
                <th>Provider</th>
                <th>Status</th>
                <th>Tokens</th>
                <th>Response</th>
              </tr>
            </thead>
            <tbody>
              {recent.map(req => (
                <tr key={req.id}>
                  <td>{new Date(req.created_at).toLocaleTimeString()}</td>
                  <td>{req.model}</td>
                  <td>{req.provider_name || '—'}</td>
                  <td>
                    <span className={`badge ${req.status_code >= 200 && req.status_code < 300 ? 'badge-success' : 'badge-error'}`}>
                      {req.status_code || 'ERR'}
                    </span>
                  </td>
                  <td>{req.tokens_used || '—'}</td>
                  <td>{req.response_time_ms ? `${req.response_time_ms}ms` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Stats;
